// Generated by ReScript, PLEASE EDIT WITH CARE


var initial_state_base_details_test = [
  undefined,
  undefined,
  undefined,
  undefined
];

var initial_state_slab_details_test = [
  undefined,
  undefined,
  undefined,
  undefined
];

var initial_state = {
  key_details: undefined,
  base_details_test: initial_state_base_details_test,
  current_base_details_test: 1,
  base_details_control: undefined,
  slab_details_test: initial_state_slab_details_test,
  current_slab_details_test: 1,
  slab_details_control: undefined,
  eligiblity_rules: undefined
};

export {
  initial_state ,
  
}
/* No side effect */
